import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/Header.module.scss';

const Loader: React.FC = () => {
  return (
    <div className={styles.loader}>
      <Spinner animation='border' variant='primary' className={styles.spinner} />
    </div>
  );
};

export default Loader;
